import { useEffect, useState } from 'react'

const useWindowBody = () => {
  const [windowBody, setWindowBody] = useState<undefined | HTMLElement>(
    undefined,
  )

  const handleResize = () => setWindowBody(window.document.body)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setWindowBody(window.document.body)
    }

    window.addEventListener('resize', handleResize)

    handleResize()

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return windowBody
}

export default useWindowBody
